import { render, staticRenderFns } from "./PageHeaderError.vue?vue&type=template&id=0c768ba8&scoped=true&"
import script from "./PageHeaderError.vue?vue&type=script&lang=ts&"
export * from "./PageHeaderError.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeaderError.vue?vue&type=style&index=0&id=0c768ba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c768ba8",
  null
  
)

export default component.exports